<template>
  <div class="bg-white rounded box-shadow p-1">
    <b-modal id="structure-modal" size="lg" title="Structure Information" hide-footer>
      <div v-show="show" class="alert alert-danger alert-dismissible fade show" role="alert">
        <span v-for="(err, index) in validation_errors" :key="index">
          {{ err[0] }} <br/>
        </span>
      </div>
      <div class="modal-content bg-white rounded box-shadow">
        <div class="form-row">
          <div class="col-md-6 col-sm-6 col-lg-6">
            <label for="land_id">Select Land <span class="c-required">*</span></label>
            <select v-model="structure.land_id" v-validate="'required'" id="land_id" name="land_id"
                    class="form-control form-control-sm" @change="cclHide(structure.land_id)">
              <option selected :value="''">Select Land</option>
              <option v-for="(land, index) in lands" v-bind:value="land.id" :key="index">Land id : {{land.id }}, Mouza : {{land.mouza.mouza_desc }}, Plot: {{ land.plot_no }}, Land Ownership: {{land.land_ownership_type.land_ownership_type_desc }}</option>
            </select>
            <div class="invalid-feedback">
              Please select valid land
            </div>
          </div>
          <div class="col-md-6 col-sm-6 col-lg-6">
            <label for="structure_use_code_id">Use of Structure <span class="c-required">*</span></label>
            <select v-model="structure.structure_use_code_id" v-validate="'required'"
                    id="structure_use_code_id" name="structure_use_code_id"
                    class="form-control form-control-sm">
              <option :value="''" selected>Select Use of Structure</option>
              <option v-for="(structure_use_code, index) in structure_use_codes"
                      v-bind:value="structure_use_code.id" :key="index">{{ structure_use_code.id }} : {{
                  structure_use_code.structure_use_code_desc }}
              </option>
            </select>
            <div class="invalid-feedback">
              Please select valid use of structure
            </div>
          </div>
        </div>
        <div class="form-row mt-2">
          <div class="col-md-6 col-sm-6 col-lg-4">
            <label for="stru_eff_roof">Roof</label>
            <input type="number" v-model="structure.stru_eff_roof" v-validate="'max:12|numeric'"
                   id="stru_eff_roof" name="stru_eff_roof" class="form-control form-control-sm"
                   placeholder="Number of roof"/>
            <div class="invalid-feedback">Please enter roof in number format and not greater then 12 digit
            </div>
          </div>
          <div class="col-md-6 col-sm-6 col-lg-4">
            <label for="stru_eff_wall">Wall</label>
            <input type="number" v-model="structure.stru_eff_wall" v-validate="'max:12|numeric'"
                   id="stru_eff_wall" name="stru_eff_wall" class="form-control form-control-sm"
                   placeholder="Number of wall"/>
            <div class="invalid-feedback">Please enter wall in number format and not greater then 12 digit
            </div>
          </div>
          <div class="col-md-6 col-sm-6 col-lg-4">
            <label for="stru_eff_floor">Floor</label>
            <input type="number" v-model="structure.stru_eff_floor" v-validate="'max:12|numeric'"
                   id="stru_eff_floor" name="stru_eff_floor" class="form-control form-control-sm"
                   placeholder="Number of floor"/>
            <div class="invalid-feedback">Please enter floor in number format and not greater then 12
              digit
            </div>
          </div>
        </div>
        <div class="form-row mt-2">
          <div class="col-md-6 col-sm-6 col-lg-4">
            <label for="stru_length">Length</label>
            <input type="number" v-model="structure.stru_length"
                   v-validate="{ max: 10, regex: /^[0-9]*(?:\.[0-9]{0,2})?$/ }" id="stru_length"
                   name="stru_length" class="form-control form-control-sm" placeholder="Structure length"/>
            <div class="invalid-feedback">Please enter structure length in number format and not greater
              then 10 digit
            </div>
          </div>
          <div class="col-md-6 col-sm-6 col-lg-4">
            <label for="stru_width">Width</label>
            <input type="number" v-model="structure.stru_width"
                   v-validate="{ max: 10, regex: /^[0-9]*(?:\.[0-9]{0,2})?$/ }" id="stru_width"
                   name="stru_width" class="form-control form-control-sm" placeholder="Structure width"/>
            <div class="invalid-feedback">Please enter structure width in number format and not greater then
              10 digit
            </div>
          </div>
          <div class="col-md-6 col-sm-6 col-lg-4">
            <label for="stru_height">Height</label>
            <input type="number" v-model="structure.stru_height"
                   v-validate="{ max: 10, regex: /^[0-9]*(?:\.[0-9]{0,2})?$/ }" id="stru_height"
                   name="stru_height" class="form-control form-control-sm" placeholder="Structure height"/>
            <div class="invalid-feedback">Please enter structure height in number format and not greater
              then 10 digit
            </div>
          </div>
        </div>
        <div class="form-row mt-2">
          <div class="col-md-6 col-sm-6 col-lg-4">
            <label for="structure_des_code_id">Code No. <span class="c-required">*</span></label>
            <select v-model="structure.structure_des_code_id" v-validate="'required'"
                    id="structure_des_code_id" name="structure_des_code_id"
                    class="form-control form-control-sm"
                    @change="getUnitCodes(structure.structure_des_code_id)">
              <option :value="''" selected>Select Code No.</option>
              <option v-for="(structure_des_code, index) in structure_des_codes"
                      v-bind:value="structure_des_code.id" :key="index">{{ structure_des_code.id }} : {{structure_des_code.structure_des_code_desc }}
              </option>
            </select>
            <div class="invalid-feedback">
              Please select valid code no.
            </div>
          </div>
          <div class="col-md-6 col-sm-6 col-lg-4">
            <label for="unit_code_id">Unit <span class="c-required">*</span></label>
            <select disabled v-model="structure.unit_code_id" v-validate="'required'" id="unit_code_id"
                    name="unit_code_id" class="custom-select custom-select-sm">
              <option :value="''" selected>Select Unit</option>
              <option v-for="(unit_code, index) in unit_codes" v-bind:value="unit_code.id" :key="index">{{
                  unit_code.id }} : {{ unit_code.unit_code_desc }}
              </option>
            </select>
            <div class="invalid-feedback">
              Please select valid unit
            </div>
          </div>
          <div class="col-md-6 col-sm-6 col-lg-4">
            <label for="qun_no">Quantity/No <span class="c-required">*</span></label>
            <input type="number" v-model="structure.qun_no"
                   v-validate="{ required:true, max: 10, regex: /^[0-9]*(?:\.[0-9]{0,2})?$/ }" id="qun_no"
                   name="qun_no" class="form-control form-control-sm" placeholder="Quantity or number"/>
            <div class="invalid-feedback">Please enter quantity in number format and not greater then 10
              digit
            </div>
          </div>
        </div>
        <div class="form-row mt-2">
          <div class="col-md-6 col-sm-6 col-lg-4">
            <label for="owner_conduct_id">Owner Conduct <span
                class="c-required">*</span></label>
            <select v-model="structure.owner_conduct_id" v-validate="'required'" id="owner_conduct_id"
                    name="owner_conduct_id" class="form-control form-control-sm">
              <option :value="''" selected>Select living/conduct Type</option>
              <option v-for="(owner_conduct, index) in owner_conducts" v-bind:value="owner_conduct.id"
                      :key="index">{{ owner_conduct.id }} : {{ owner_conduct.owner_conduct_desc }}
              </option>
            </select>
            <div class="invalid-feedback">
              Please select owner himself living/conduct
            </div>
          </div>
          <div class="col-md-6 col-sm-6 col-lg-4">
            <label for="remarks">Amount</label>
            <input v-model="structure.amounts"  v-validate="'decimal:4'" id="amount" name="amount" type="number"
                   class="form-control form-control-sm"/>
                   <div class="invalid-feedback">Please enter tree saplings in number format and not greater then 10 digit</div>
          </div>
          <div class="col-md-6 col-sm-6 col-lg-4">
            <label for="remarks">Remarks</label>
            <input v-model="structure.remarks" id="remarks" name="remarks" type="text"
                   class="form-control form-control-sm"/>
          </div>
        </div>
        <div v-if="cclShow">
          <h5 class="modal-sub-header">CCL Information</h5>
          <div class="form-row">
            <div class="col-md-6 col-sm-6 col-lg-4">
              <label for="ccl_id">CCL<span class="c-required">*</span></label>
              <select v-model="structure.ccl_id" @change="getCclInfo(structure.ccl_id)"  id="ccl_id" name="ccl_id" class="form-control form-control-sm">
                <option :value="''" selected>Select CCL</option>
                <option v-for="(ccl_structure, index) in ccl_structures" v-bind:value="ccl_structure.id" :key="index">{{ ccl_structure.ccl_no }}</option>
              </select>
            </div>
            <div class="col-md-6 col-sm-6 col-lg-4">
              <label for="ccl_amount" class="col-form-label col-form-label-sm">CCL Amount <span class="c-required">*</span></label>
              <input type="number" v-model="structure.ccl_amount" v-validate="'required|decimal'" id="ccl_amount" name="ccl_amount" placeholder="CCL Amount" class="form-control form-control-sm"/>
              <div class="invalid-feedback">Please provide valid CCL Amount</div>
            </div>
            <div class="col-md-6 col-sm-6 col-lg-4">
              <label for="cheque_date" class="col-form-label col-form-label-sm">Cheque Date</label>
              <input type="text" disabled v-model="ccl.cheque_date" id="cheque_date" name="cheque_date" class="custom-select custom-select-sm"/>
            </div>
          </div>
          <div class="form-row">
            <div class="col-md-6 col-sm-6 col-lg-4">
              <label for="book_no" class="col-form-label col-form-label-sm">Book No</label>
              <input type="text" disabled v-model="ccl.book_no" id="book_no" name="book_no" class="custom-select custom-select-sm"/>
            </div>
            <div class="col-md-6 col-sm-6 col-lg-4">
              <label for="book_sub_no" class="col-form-label col-form-label-sm">Sub Book No</label>
              <input type="text" disabled v-model="ccl.book_sub_no" id="book_sub_no" name="book_sub_no" class="custom-select custom-select-sm"/>
            </div>
            <div class="col-md-6 col-sm-6 col-lg-4">
              <label for="amount" class="col-form-label col-form-label-sm">Total Amount</label>
              <input type="text" disabled v-model="ccl.amount" id="amount" name="amount" class="custom-select custom-select-sm"/>
            </div>
          </div>
        </div>

        <div class="form-row mt-3 mb-3">
          <div class="float-right">
            <b-button v-if="!this.btn_edit" class="form-control-sm mr-2" size="sm" variant="success"
                      @click.prevent="save">Add Structure
            </b-button>
            <b-button v-if="this.btn_edit" class="form-control-sm mr-2" size="sm" variant="warning"
                      @click.prevent="update">Update Structure
            </b-button>
            <b-button size="sm" variant="danger" class="form-control-sm"
                      @click="$bvModal.hide('structure-modal')">Cancel
            </b-button>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import http from "@state/http";
import moment from "moment";
import Datepicker from "vuejs-datepicker";

export default {
  props: ["structure", "btn_edit", "cclShow"],

  components: {Datepicker},
  data() {
    return {
      lands: [],
      structure_use_codes: [],
      structure_des_codes: [],
      unit_codes: [],
      owner_conducts: [],
      data_ccl_structures: [],
      ccl_structures: [],
      validation_errors: {},
      show: false,
      ccl: {},
    };
  },
  mounted() {
    this.getCodes();
  },
  methods: {
    customFormatter(date) {
      this.structure.cheque_date = moment(date).format("YYYY-MM-DD");
      return moment(date).format("YYYY-MM-DD");
    },

    clearCCl(){
      this.ccl = {};
    },
    cclHide(land_id) {

      this.lands.filter(function(elem) {
        if(elem.id === land_id)
        {
          //this.$emit("cclShowUpdate", elem.land_ownership_type_id == 1 ? true : false);
          this.$emit("cclShowUpdate", elem.land_ownership_type_id === 1 || 2 || 3);

          this.getCcls(elem.plot_no,elem.mouza_id)
        }
      }.bind(this));
      this.getCclStructure(land_id);
    },

    getCclStructure(land_id) {
      let land = this.lands.find(l => l.id == land_id);

      var filteredArray = this.data_ccl_structures.filter(element =>
          element.mouza_id === land.mouza_id
      )
      this.ccl_structures = filteredArray;
    },
    save() {
      this.$validator.validate().then(valid => {
        if (valid) {
          http
              .post("api/structures", this.structure)
              .then(response => {
                if (!response.data.error) {
                  this.$emit("resetForm");
                  this.$bvToast.toast(response.data.message, {
                    title: "Success",
                    autoHideDelay: 5000,
                    variant: "success"
                  });
                  this.$bvModal.hide("structure-modal");
                  this.$emit("getPersonStructure");
                }
              })
              .catch(error => {
                this.validation_errors = error.response.data.errors;
                this.show = true;
                this.hide();
              });
        }
      });
    },
    update() {
      this.$validator.validate().then(valid => {
        if (valid) {
          http.put("api/structures/" + this.structure.id, this.structure)
              .then(response => {
                if (!response.data.error) {
                  this.$bvModal.hide("structure-modal");
                  this.$bvToast.toast(response.data.message, {
                    title: "Success",
                    autoHideDelay: 5000,
                    variant: "success"
                  });
                  this.$emit("getPersonStructure");
                }
                if(response.data.error == true) {
                  this.$bvToast.toast(response.data.message, {
                    title: "Error",
                    autoHideDelay: 5000,
                    variant: "danger"
                  });
                }
              })
              .catch(error => {
                this.validation_errors = error.response.data.errors;
                this.show = true;
                this.hide();
                this.$bvToast.toast("Update Failed", {
                  title: "Error",
                  autoHideDelay: 5000,
                  variant: "danger"
                });
              });
        }
      });
    },
    getCodes() {
      let ses_id = this.$route.params.ses_id;
      http.get("api/structure/codes/" + ses_id).then(response => {
        if (!response.error) {
          let data = response.data;
          this.lands = data.lands;
          this.structure_use_codes = data.structure_use_codes;
          this.structure_des_codes = data.structure_des_codes;
          this.owner_conducts = data.owner_conducts;
          this.unit_codes = data.unit_codes;
          //this.data_ccl_structures = data.ccl_structures;

        }
      });
    },
    getUnitCodes(structure_des_code_id) {
      let structure_des_code = this.structure_des_codes.find(structure_des_code => structure_des_code.id == structure_des_code_id);

      let unit_code = this.unit_codes.find(unit_code => unit_code.id == structure_des_code.unit_code_id);
      this.structure.unit_code_id = unit_code.id;
    },

    getCcls(plot_no,mouza_id) {

      let ccl_type_id = 2;
      http.get("api/ccl/getCcls/" + ccl_type_id +'/'+ plot_no + '/'+ mouza_id).then(response => {
        if (!response.error) {
          this.ccl_structures = response.data.plot_mouza_ccls;
          console.log(this.ccl_structures);
        }
      });
    },
    getCclInfo(ccl_id){

      if(this.ccl_structures.length>0) {
        let ccl_structure = this.ccl_structures.find(v => v.id == ccl_id);
        //console.log(this.ccl_structure);
        this.ccl = ccl_structure
        // this.ccl.cheque_date = ccl_structure.cheque_date
        // this.ccl.book_no = ccl_structure.book_no
        // this.ccl.book_sub_no = ccl_structure.book_sub_no
        // this.ccl.amount = ccl_structure.amount
        // this.ccl.id = ccl_structure.id


      }
    },


    hide() {
      setTimeout(() => {
        this.show = false;
      }, 5000);
    },
  },
};
</script>
<style>
.c-required {
  color: red;
}
</style>
